@if (instrument) {
  <div class="button-container">
    <div class="input-container">
      <div
        class="togglable"
        (click)="toggle()"
        tabindex="0"
        (keydown.space)="toggle()"
        (keydown.enter)="toggle()"
        >
        <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
        <div class="name" [ngClass]="{ 'name--cash': cash }">
          @if (cash) {
            {{ 'global.cash' | translate }}
          } @else {
            {{ instrument.humanName }}
          }
        </div>
      </div>
      <div class="inputs">
        <button
          class="control-button"
          (click)="clickedMinus()"
          data-cy="instrument-dropdown-minus-weight"
          [ngClass]="{'control-button--disabled': formName.value.value <= min}"
          #tooltipUnderMinHoverable
          >
          <svg-icon src="assets/icons/minus.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
        </button>
        @if ((formName.value.value <= min) && !!minDisabledTooltip) {
          <div #tooltipUnderMinimumContent style="display: none;">
            @if ((formName.value.value <= min) && !!minDisabledTooltip) {
              <div class="tooltip-content" data-cy="dropdown-minus-disabled-tooltip">
                <div class="tooltip-text"> {{ 'tooltip.' + minDisabledTooltip | translate }} </div>
              </div>
            }
          </div>
        }
        <div
          class="input-value-container"
          ngClass="{{ invalidInput() ? 'input-value-container--invalid' : '' }}"
          [attr.data-cy]="cash ? 'cash-strategy-instrument-container' : (instrument.isin + '-strategy-instrument-input-container')"
          >
          <input
            class="input-value"
            [ngClass]="{'input-value--disabled': disabledTextInput}"
            [(ngModel)]="currentInputValue"
            type="number"
            [min]="min"
            [max]="max"
            (input)="inputUpdated()"
            [attr.data-cy]="cash ? 'cash-strategy-instrument-input' : (instrument.isin + '-strategy-instrument-input')"
            [disabled]="!!disabledTextInput"
          >
            <div class="input-units">
              %
            </div>
          </div>
          <button class="control-button" (click)="clickedPlus()" [ngClass]="{'control-button--disabled': currentInputValue >= max}" data-cy="instrument-dropdown-plus-weight" #tooltipOverMaxHoverable>
            <svg-icon src="assets/icons/plus.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
          </button>
          @if (maxDisabledTooltip) {
            <div #tooltipOverMaximumContent style="display: none;">
              <div class="tooltip-content" data-cy="dropdown-plus-disabled-tooltip">
                <div class="tooltip-text"> {{ 'tooltip.' + maxDisabledTooltip | translate }} </div>
              </div>
            </div>
          }
        </div>
      </div>
      @if (toggled) {
        <div class="description">
          @if (instrument.name) {
            <div class="real-name">
              {{ instrument.name }}
            </div>
          }
          <div class="mt-2">
            @if (instrument.description) {
              {{ instrument.description }}
            } @else if (!instrument['cashInstrument'].cash && !instrument.cash) {
              {{ 'global.error.instrumentWithoutDescription' | translate }}
            } @else {
              {{ 'global.cashDescription' | translate }}
            }
          </div>
          <div class="mt-2">
            @if (instrument.web) {
              <a
                class="description-web"
                href="{{ instrument.web }}"
                target="_blank"
                >
                {{ 'dropdown.productsWeb' | translate }}
              </a>
            }
          </div>
        </div>
      }
    </div>
  }
